export class ChartModel {
cmbChart: string;
setValue(res){
if(res){
if(res['cmbChart']){this.cmbChart = res['cmbChart'];}
}
}
}